import { render, staticRenderFns } from "./Perioden.vue?vue&type=template&id=6d195500&"
import script from "./Perioden.vue?vue&type=script&lang=js&"
export * from "./Perioden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports